"use strict";

var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator/index.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeExternalConstants = void 0;

require("isomorphic-unfetch");

var _constants = require("../constants");

var _retryFetch = require("./retryFetch");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var initializeExternalConstants = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apiKey, networkName, url, fetchOptions, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiKey = _ref.apiKey, networkName = _ref.networkName;
            url = "".concat(_constants.CLOUD_URI, "/developer");
            fetchOptions = {
              headers: {
                'api-key': apiKey || 'anonymous',
                'api-version': !networkName ? _constants.API_VERSION : "".concat(_constants.API_VERSION, "-").concat(networkName)
              }
            };
            _context.next = 5;
            return (0, _retryFetch.retryFetch)(url, fetchOptions);

          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.json();

          case 8:
            return _context.abrupt("return", _context.sent);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initializeExternalConstants(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.initializeExternalConstants = initializeExternalConstants;